
import React, { useState, useRef, useEffect } from "react";
import { postData } from "../../../../../ApiServices/ApiService";
import { ORG_CONFIGURATION_TEMPLETE_LIST } from "../../../../../ApiServices/BaseURL";
import { logFrontendException } from "../../../../../Utils/Exception";
import { useTheme } from "../../../../../GlobalContext/GlobalContext";

const SMSTemplateListController = (data, loading, error, refreshHandlers) => {
    const [filterData, setFilterData] = useState({
        templateName: "",
        createdBy: "",
        createdDate: "",
    });

    const [smsTemplateData, setSmsTemplateData] = useState([]);
    const [filterLoading, setFilterLoading] = useState(false);
    const [filterError, setFilterError] = useState('');

    const [filterSelectionError, setFilterSelectionError] = useState('');
    const [showFilters, setShowFilters] = useState(false);

    const { setIsLoginPopup } = useTheme();

    const [expandedRows, setExpandedRows] = useState({});
    const toggleExpand = (key) => {
        setExpandedRows((prev) => ({
            ...prev,
            [key]: !prev[key],
        }));
    };

    const handleInputChange = (field, value) => {
        setFilterData((prevData) => ({
            ...prevData,
            [field]: value,
        }));
    };

    useEffect(() => {
        if (data) {
            setSmsTemplateData(data);
        }
        setFilterError(error);
        setFilterLoading(loading);
    }, [data, error, loading]);

    const pageName = "SMSTemplateListController";

    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;
    const totalPages = Math.ceil(smsTemplateData?.length / itemsPerPage);
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentTasks = smsTemplateData?.slice(indexOfFirstItem, indexOfLastItem);

    const handlePageChange = (pageNumber) => {
        if (pageNumber > 0 && pageNumber <= totalPages) {
            setCurrentPage(pageNumber);
        }
    };

    const maxVisiblePages = 3;

    const getVisiblePages = () => {
        const startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
        const endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);

        // Adjust startPage if we're near the end
        const adjustedStartPage = Math.max(1, endPage - maxVisiblePages + 1);

        return Array.from({ length: endPage - adjustedStartPage + 1 }, (_, index) => adjustedStartPage + index);
    };

    const visiblePages = getVisiblePages();

    const fetchSmsTemplateFilter = async () => {
        setFilterError('');
        setFilterSelectionError('');
        setExpandedRows({});
        if (!(filterData?.templateName.trim() || filterData?.createdBy || filterData?.createdDate)) {
            setFilterSelectionError('Please enter/select any one of the above');
            return;
        }
        setFilterLoading(true);
        setSmsTemplateData([]);
        setCurrentPage(1);

        const storedUser = JSON.parse(localStorage.getItem("_userInfo_"));

        try {
            const payload = {
                channel_name: 'sms',
                emp_id_auth: storedUser?.emp_id,
                template_name: filterData?.templateName,
                created_by: filterData?.createdBy,
                created_at: filterData?.createdDate,
            };

            const response = await postData(ORG_CONFIGURATION_TEMPLETE_LIST, payload);
            const responseData = await response.json();

            if (response?.status === 200) {
                if (responseData?.status_code === 200) {
                    if (responseData?.message?.toLowerCase() === "success") {
                        if (responseData?.dataJ?.length > 0) {
                            setSmsTemplateData(responseData?.dataJ);
                        } else {
                            setFilterError(responseData?.info || "No templates are available.");
                            logFrontendException(storedUser?.emp_id, pageName, 'fetchSmsTemplateFilter', responseData?.info);
                        }
                    } else {
                        setFilterError(responseData?.info || "Failed to fetch templates.");
                        logFrontendException(storedUser?.emp_id, pageName, 'fetchSmsTemplateFilter', responseData?.info);
                    }
                } else {
                    setFilterError(responseData?.info || "Unable to fetch templates.Please try again later.");
                    logFrontendException(storedUser?.emp_id, pageName, 'fetchSmsTemplateFilter', responseData);
                }
            } else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
                setFilterError('Unauthorized access. Your session may have expired. Please log in again.');
                setIsLoginPopup(true)
                logFrontendException(storedUser?.emp_id, pageName, 'fetchSmsTemplateFilter', response || '');
            } else {
                setFilterError("Failed to fetch templates.Please try again.");
                logFrontendException(storedUser?.emp_id, pageName, 'fetchSmsTemplateFilter', response || '');
            }
        } catch (err) {
            setFilterError("Unable to fetch templates.Please check your internet connection and try again.");
            logFrontendException(storedUser?.emp_id, pageName, 'fetchSmsTemplateFilter', err);
        } finally {
            setFilterLoading(false);
        }
    };

    const toggleFilters = () => {
        setShowFilters((prev) => !prev); // Toggle the filter visibility
    };

    const resetFilters = () => {
        if (filterData?.templateName || filterData?.createdBy || filterData?.createdDate) {
            setSmsTemplateData([]);
            setCurrentPage(1);
            setFilterError('');
            refreshHandlers?.sms?.();
        }
        setFilterSelectionError('');
        setFilterData({
            templateName: "",
            createdBy: "",
            createdDate: "",
        });
        setExpandedRows({});
    };

    const cancelFilters = () => {
        resetFilters();
        setShowFilters(!showFilters);
    }

    return {
        smsTemplateData: currentTasks,
        filterData,
        setFilterData,
        handleInputChange,
        filterError,
        filterLoading,
        currentPage,
        totalPages,
        handlePageChange,
        visiblePages,
        fetchSmsTemplateFilter,
        resetFilters,
        cancelFilters,
        showFilters,
        toggleFilters,
        filterSelectionError,
        expandedRows,
        toggleExpand,
        setExpandedRows,
    }

}

export default SMSTemplateListController